(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    class ProductRotatingBadges {
  constructor(element) {
    this.element = element;
    this.badges = element.querySelectorAll('.product-badge-item');
    this.currentIndex = 0;
    this.duration = parseInt(element.dataset.badgeDuration) * 1000 || 3000;
    this.transitionSpeed = parseInt(element.dataset.transitionSpeed) || 300;
    this.pauseOnHover = element.dataset.pauseOnHover === 'true';
    this.isPaused = false;
    this.intervalId = null;

    if (this.badges.length > 1) {
      this.init();
    }
  }

  init() {
    // Configurar velocidade de transição
    this.badges.forEach(badge => {
      badge.style.transitionDuration = `${this.transitionSpeed}ms`;
    });

    // Iniciar rotação
    this.startRotation();

    // Pausar ao hover se configurado
    if (this.pauseOnHover) {
      this.element.addEventListener('mouseenter', () => this.pause());
      this.element.addEventListener('mouseleave', () => this.resume());
    }
  }

  startRotation() {
    this.intervalId = setInterval(() => {
      if (!this.isPaused) {
        this.next();
      }
    }, this.duration);
  }

  next() {
    // Remover active da badge atual
    this.badges[this.currentIndex].classList.remove('active');

    // Incrementar índice
    this.currentIndex = (this.currentIndex + 1) % this.badges.length;

    // Adicionar active na próxima badge
    this.badges[this.currentIndex].classList.add('active');
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    this.isPaused = false;
  }

  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}

// Inicializar badges quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  const badgeElements = document.querySelectorAll('.product-rotating-badges');
  badgeElements.forEach(element => {
    new ProductRotatingBadges(element);
  });
});

// Reinicializar ao trocar de tema (Shopify Theme Editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    const badgeElements = document.querySelectorAll('.product-rotating-badges');
    badgeElements.forEach(element => {
      new ProductRotatingBadges(element);
    });
  });
}
  } catch(e) { console.error(e); }
})();

})();
